import { Directive, Input, TemplateRef } from '@angular/core';
@Directive({
    selector: '[dynamic-template]'
})

export class DynamicTemplateDirective {
    @Input() templateName: string;

    constructor(public template: TemplateRef<any>) { }
}
